import React from 'react';
import { useNavigate } from 'react-router-dom';
import './foodToAvoid.css';
import pawImg from '../assets/paw.png';
import buttonStyles from '../components/Buttons.module.css';

const FeedingPortions: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <div className="page-container cream-bg">
      {/* Floating Paw Print Background */}
      <div className="hero-paw-bg">
        <img src={pawImg} className="hero-paw-float paw1" alt="" />
        <img src={pawImg} className="hero-paw-float paw2" alt="" />
        <img src={pawImg} className="hero-paw-float paw3" alt="" />
        <img src={pawImg} className="hero-paw-float paw4" alt="" />
        <img src={pawImg} className="hero-paw-float paw5" alt="" />
        <img src={pawImg} className="hero-paw-float paw6" alt="" />
        <img src={pawImg} className="hero-paw-float paw7" alt="" />
      </div>

      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '2rem 2rem 0' }}>
        <button
          className={`${buttonStyles.antBtn} ${buttonStyles.antBtnSecondary}`}
          style={{ fontSize: '1.08rem', padding: '0.7em 1.6em', borderRadius: '14px', fontWeight: 600 }}
          onClick={() => navigate(-1)}
          aria-label="Go back"
        >
          ← Back
        </button>
      </div>

      <div className="page-intro">
        <h1 className="page-title">How Much Homemade Food to Feed Your Dog</h1>
        <div className="page-intro-underline" />
      </div>

      <div className="content-section" style={{margin: '0 auto', padding: '0 1.5rem 3rem 1.5rem' }}>
        <div style={{ background: '#fff', borderRadius: 16, padding: '2rem 2.5rem', boxShadow: '0 4px 12px rgba(44,62,80,0.08)', lineHeight: 1.8 }}>
          
          <p style={{ fontSize: '1.1rem', marginBottom: '2.5rem', color: '#555' }}>
            Feeding the right amount of homemade food depends on your dog's weight, age, body condition, and how many meals they eat per day. The amounts below are general guidelines to help you estimate daily portions.
          </p>

          <h2 style={{ color: '#b24646', fontSize: '1.6rem', marginTop: '2rem', marginBottom: '1rem', fontWeight: 700 }}>General Feeding Guideline</h2>
          
          <p style={{ marginBottom: '1rem', color: '#555' }}>
            Most adult dogs eat about:
          </p>

          <p style={{ fontSize: '1.15rem', fontWeight: 600, color: '#d97706', marginBottom: '1.5rem', marginLeft: '1.5rem' }}>
            2–3% of their body weight per day in fresh food.
          </p>

          <p style={{ marginBottom: '2rem', color: '#555' }}>
            This amount can vary depending on age and body condition.
          </p>

          <h2 style={{ color: '#b24646', fontSize: '1.6rem', marginTop: '2.5rem', marginBottom: '1rem', fontWeight: 700 }}>Example Feeding Amounts</h2>
          
          <div style={{ overflowX: 'auto', marginBottom: '2rem' }}>
            <table style={{ 
              width: '100%', 
              borderCollapse: 'collapse', 
              marginBottom: '1.5rem',
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
            }}>
              <thead>
                <tr style={{ background: '#fff7f0', borderBottom: '2px solid #d97706' }}>
                  <th style={{ padding: '1rem', textAlign: 'left', color: '#b24646', fontWeight: 700 }}>Dog Weight</th>
                  <th style={{ padding: '1rem', textAlign: 'left', color: '#b24646', fontWeight: 700 }}>Daily Food Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ borderBottom: '1px solid #ffd1ba' }}>
                  <td style={{ padding: '0.9rem 1rem', color: '#555' }}>10 lb (4.5 kg)</td>
                  <td style={{ padding: '0.9rem 1rem', color: '#555' }}>100–135 g</td>
                </tr>
                <tr style={{ background: '#fffbf7', borderBottom: '1px solid #ffd1ba' }}>
                  <td style={{ padding: '0.9rem 1rem', color: '#555' }}>20 lb (9 kg)</td>
                  <td style={{ padding: '0.9rem 1rem', color: '#555' }}>180–270 g</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #ffd1ba' }}>
                  <td style={{ padding: '0.9rem 1rem', color: '#555' }}>40 lb (18 kg)</td>
                  <td style={{ padding: '0.9rem 1rem', color: '#555' }}>360–540 g</td>
                </tr>
                <tr style={{ background: '#fffbf7', borderBottom: '1px solid #ffd1ba' }}>
                  <td style={{ padding: '0.9rem 1rem', color: '#555' }}>60 lb (27 kg)</td>
                  <td style={{ padding: '0.9rem 1rem', color: '#555' }}>540–810 g</td>
                </tr>
                <tr>
                  <td style={{ padding: '0.9rem 1rem', color: '#555' }}>80 lb (36 kg)</td>
                  <td style={{ padding: '0.9rem 1rem', color: '#555' }}>720–1080 g</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p style={{ fontSize: '1.05rem', fontStyle: 'italic', color: '#7a3a3a', marginBottom: '2.5rem' }}>
            Most adult dogs do well with two meals per day.
          </p>

          <h2 style={{ color: '#b24646', fontSize: '1.6rem', marginTop: '2.5rem', marginBottom: '1rem', fontWeight: 700 }}>Puppies Need More Food</h2>
          
          <p style={{ marginBottom: '1rem', color: '#555' }}>
            Growing puppies require more calories than adult dogs.
          </p>

          <p style={{ marginBottom: '0.5rem', color: '#555', fontWeight: 600 }}>
            Typical guideline:
          </p>

          <p style={{ fontSize: '1.15rem', fontWeight: 600, color: '#d97706', marginBottom: '0.5rem', marginLeft: '1.5rem' }}>
            4–6% of body weight per day
          </p>

          <p style={{ fontSize: '1.05rem', color: '#555', marginBottom: '1.5rem', marginLeft: '1.5rem' }}>
            divided into 3–4 meals daily
          </p>

          <p style={{ marginBottom: '2rem', color: '#555' }}>
            Puppies grow quickly, so feeding amounts should be adjusted as they gain weight.
          </p>

          <h2 style={{ color: '#b24646', fontSize: '1.6rem', marginTop: '2.5rem', marginBottom: '1rem', fontWeight: 700 }}>Active Dogs May Need More</h2>
          
          <p style={{ marginBottom: '1rem', color: '#555' }}>
            Highly active dogs may require more food than the general guideline.
          </p>

          <p style={{ marginBottom: '0.5rem', color: '#555' }}>
            Examples include:
          </p>

          <ul style={{ marginLeft: '2rem', marginBottom: '1.5rem', color: '#555' }}>
            <li>working dogs</li>
            <li>agility dogs</li>
            <li>hunting dogs</li>
          </ul>

          <p style={{ marginBottom: '2rem', color: '#555' }}>
            These dogs may need 3–4% of body weight per day depending on their activity level.
          </p>

          <h2 style={{ color: '#b24646', fontSize: '1.6rem', marginTop: '2.5rem', marginBottom: '1rem', fontWeight: 700 }}>Dogs Needing Weight Loss</h2>
          
          <p style={{ marginBottom: '1rem', color: '#555' }}>
            Dogs that need to lose weight may require slightly smaller portions.
          </p>

          <p style={{ marginBottom: '0.5rem', color: '#555', fontWeight: 600 }}>
            Typical guideline:
          </p>

          <p style={{ fontSize: '1.15rem', fontWeight: 600, color: '#d97706', marginBottom: '1.5rem', marginLeft: '1.5rem' }}>
            1.5–2% of body weight per day
          </p>

          <p style={{ marginBottom: '2rem', color: '#555' }}>
            Portion adjustments should always be made gradually.
          </p>

          <h2 style={{ color: '#b24646', fontSize: '1.6rem', marginTop: '2.5rem', marginBottom: '1rem', fontWeight: 700 }}>Monitor Your Dog</h2>
          
          <p style={{ marginBottom: '1rem', color: '#555' }}>
            Every dog is different. The best way to determine if you are feeding the right amount is to monitor your dog's body condition.
          </p>

          <p style={{ marginBottom: '0.5rem', color: '#555', fontWeight: 600 }}>
            Healthy signs include:
          </p>

          <ul style={{ marginLeft: '2rem', marginBottom: '1.5rem', color: '#555' }}>
            <li>ribs can be felt easily but are not prominent</li>
            <li>a visible waist when viewed from above</li>
            <li>normal energy levels</li>
            <li>stable body weight</li>
          </ul>

          <p style={{ marginBottom: '2.5rem', color: '#555' }}>
            If your dog gains or loses weight unexpectedly, adjust portions slowly.
          </p>

          <div style={{ 
            background: 'linear-gradient(135deg, #fff7f0 0%, #ffe8d6 100%)', 
            border: '2px solid #d97706', 
            borderRadius: 12, 
            padding: '1.5rem 2rem',
            marginTop: '2rem'
          }}>
            <h3 style={{ color: '#b24646', fontSize: '1.3rem', marginTop: 0, marginBottom: '0.8rem', fontWeight: 700 }}>Helpful Tip</h3>
            <p style={{ margin: 0, color: '#555', fontSize: '1.05rem' }}>
              When starting homemade food, it's best to measure portions for a few weeks so you can see what amount works best for your dog.
            </p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default FeedingPortions;
